import { OrgPodcast } from '@/modules/manager/components/org/podcast';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(OrgPodcast);

export const roles: string[] = [];
export const path = '/manager/:orgId/podcast/:podcastId';
export const element = <AnimatedPage />